import loaded from '@/scripts/utils/loaded.js';
import { scrollToY } from '@/scripts/utils/dom.js';

// Fade the button in/out only when the state flips; a newer fade supersedes a running one.
function createFader(el, duration = 400) {
    let visible = null;
    let animation = null;

    return (show) => {
        if (visible === show) return;
        visible = show;

        const wasRendered = !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        // Read the in-flight opacity before cancelling so a reversed fade starts where the last one was.
        const current = wasRendered ? getComputedStyle(el).opacity : 0;

        if (animation) animation.cancel();

        if (show) {
            el.style.display = 'block';
        } else if (!wasRendered) {
            el.style.display = 'none';
            return;
        }
        animation = el.animate([{opacity: current}, {opacity: show ? 1 : 0}], {duration, easing: 'ease'});
        animation.onfinish = () => {
            animation = null;
            if (!show) el.style.display = 'none';
        };
    };
}

loaded(() => {
    const backTop = document.getElementById('back-top');
    if (!backTop) return;

    const fade = createFader(backTop);

    window.addEventListener('scroll', function () {
        fade(window.scrollY > 600);
    }, {passive: true});

    // scroll body to 0px on click
    if (backTop.matches('a')) {
        backTop.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            scrollToY(0);
        });
    }
});
